/* chr-announce.js — WS-CHROME: slim rotating announcement bar. Vanilla. One message at a time, pause/play,
   pause on hover/focus, dismiss per session (sessionStorage), reduced-motion safe (instant swap, no slide). */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.__chr) return;
    root.__chr = true;
    var list = root.querySelector('[data-chr-ann-list]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.chr-ann__msg'));
    var tgl = root.querySelector('[data-chr-ann-toggle]');
    var close = root.querySelector('[data-chr-ann-close]');
    var section = root.closest('.shopify-section');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5500;
    var idx = 0, timer = null, userPaused = false, hold = false;

    function setTab(el, on) {
      var a = el.querySelector('a');
      if (a) a.tabIndex = on ? 0 : -1;
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    items.forEach(function (el, i) { setTab(el, i === 0); });

    function show(n) {
      if (n === idx || !items.length) return;
      var prev = items[idx];
      prev.classList.add('is-leaving');
      prev.classList.remove('is-active');
      setTab(prev, false);
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 480);
      idx = (n + items.length) % items.length;
      items[idx].classList.add('is-active');
      setTab(items[idx], true);
    }
    function next() { show((idx + 1) % items.length); }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (items.length < 2 || userPaused || hold || document.hidden) return;
      timer = setInterval(next, interval);
    }
    function setLive() { if (list) list.setAttribute('aria-live', (userPaused || hold) ? 'polite' : 'off'); }

    if (tgl) {
      tgl.addEventListener('click', function () {
        userPaused = !userPaused;
        root.classList.toggle('is-paused', userPaused);
        tgl.setAttribute('aria-label', tgl.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause'));
        setLive();
        if (userPaused) stop(); else start();
      });
    }
    root.addEventListener('mouseenter', function () { hold = true; setLive(); stop(); });
    root.addEventListener('mouseleave', function () { hold = false; setLive(); start(); });
    root.addEventListener('focusin', function () { hold = true; setLive(); stop(); });
    root.addEventListener('focusout', function () { hold = false; setLive(); start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    if (close && section) {
      close.addEventListener('click', function () {
        try { sessionStorage.setItem('chr-ann-off', '1'); } catch (e) {}
        document.documentElement.classList.add('chr-ann-off');
        stop();
        window.dispatchEvent(new Event('resize'));
      });
    }
    start();
  }
  function boot() { document.querySelectorAll('[data-chr-ann]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
